import cat1 from "./assets/cat1.png";
import cat2 from "./assets/cat2.png";
import cat3 from "./assets/cat3.png";
import cat4 from "./assets/cat4.png";

export const cats = [
  {
    src: cat1,
    name: "Patty"
  },
  {
    src: cat2,
    name: "Mittens"
  },
  {
    src: cat3,
    name: "Mr.Scratch"
  },
  {
    src: cat4,
    name: "Trüffel"
  }
];
